export enum PendingTaskType {
ApproveLeave,
CheckLeaveData,
Information,
}
